import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import "./Navigation.scss";
import { FormattedMessage } from "react-intl";
import { setCurrentLocale } from "../../../../store/intl/intlActions";
import { connect } from "react-redux";
import { getUserSettings } from "../../../../store/auth/authSelectors";
import { logout } from "../../../../store/auth/authActions";

function Navigation({ setLocale, currentLocale, user, logout, locale }) {
  const [langMenuVisible, setLangMenuVisible] = useState(false);
  const [userMenuVisible, setUserMenuVisible] = useState(false);
  const [lang, setLang] = useState(currentLocale);
  const navigationRef = useRef();
  const history = useHistory();
  const [menuVisible, setMenuVisible] = useState(false);
  function handleLanguage(language) {
    setLang(language);
    setLocale(language);
    localStorage.setItem("selectedLanguage", language);
    setMenuVisible(false);

    if (language === 'cs') {
      history.push('/cs')
    } else {
      history.push('/')
    }
  }
  useEffect(() => {
    function handleNavigation() {
      if (window.pageYOffset > 0) {
        navigationRef.current.classList.add("scrolled");
      } else {
        navigationRef.current.classList.remove("scrolled");
      }
    }
    if (lang === "cs") {
      history.push('/cs')
    } else {
      history.push('/')
    }

    window.addEventListener("scroll", handleNavigation);
    localStorage.setItem("selectedLanguage", lang);
    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, []);
  useEffect(() => {
    function handleToggle() {
      if (langMenuVisible) {
        setLangMenuVisible(false);
      }
      if (userMenuVisible) {
        setUserMenuVisible(false);
      }
    }
    window.addEventListener("click", handleToggle);
    return () => {
      window.removeEventListener("click", handleToggle);
    };
  }, [langMenuVisible,userMenuVisible]);

  // Smooth animation for scrolling navigation
  useEffect(() => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute("href")).scrollIntoView({
          behavior: "smooth",
        });
      });
    });
  });

  return (
    <div ref={navigationRef} id="Navigation">
      <img
        onClick={() => {
          history.push("/");
          // window.location.reload();
          window.scrollTo(0, 0);
        }}
        className="logo"
        src="/lib/images/logo.svg"
      />
      <div className="navigation-list">
        <HashLink className="a" smooth to="/#introduction">
          <span>
            <FormattedMessage id="home.navigation.introduction" />
          </span>
        </HashLink>
        <HashLink className="a" smooth to="/#qr-codes">
          <span>
            <FormattedMessage id="home.navigation.qrcodes" />
          </span>
        </HashLink>
        <HashLink className="a" smooth to="/#pricing">
          <span>
            <FormattedMessage id="home.navigation.pricing" />
          </span>
        </HashLink>
        <HashLink className="a" smooth to="/#contact">
          <span>
            <FormattedMessage id="home.navigation.contact" />
          </span>
        </HashLink>
        {user ? <>
        <div className="user-wrapper">
          <button onClick={()=>setUserMenuVisible(true)} className="green-button outline user">
            <img alt="" src="images/user-green.svg" />
          </button>
          <div className={`user-menu ${userMenuVisible ? "active" : ""}`}>
            <div className="name">{user ? user.name : ""}</div>
            <div className="email">{user ? user.email : ""}</div>
            <div onClick={()=>logout()} className="logout"><img src="images/main-menu/exit.svg" alt="" /><FormattedMessage id="home.navigation.logout" /></div>
          </div>
        </div>
        <HashLink className="button" smooth to="/app/dashboard/home">
          <button className="green-button">
            <FormattedMessage id="home.navigation.toapp" />
            <div className="arrow-wrapper">
              <img alt="" src="images/icons/white-arrow.svg" />
            </div>
          </button>
        </HashLink>
        </> : <>
        <HashLink className="button" smooth to="/login">
          <button className="green-button outline">
            <FormattedMessage id="home.navigation.login" />
          </button>
        </HashLink>
        <HashLink className="button" smooth to="/signup">
          <button className="green-button">
            <FormattedMessage id="home.navigation.register" />
          </button>
        </HashLink>
        </>}
        <div
          onClick={() => setLangMenuVisible(!langMenuVisible)}
          className={`lang-button ${langMenuVisible && "active"}`}
        >
          {lang === "cs" ? "CZ" : "EN"}
          <img src="/lib/images/arrow-gray.svg" alt="" />
          <div className={`lang-menu ${langMenuVisible && "active"}`}>
            <span
              onClick={() => {
                handleLanguage("cs");
              }}
            >
              Česky
            </span>
            <span
              onClick={() => {
                handleLanguage("en");
              }}
            >
              English
            </span>
          </div>
        </div>
      </div>
      <div className="mobile-section">{user ? <>
        <div className="user-wrapper">
          <button onClick={()=>setUserMenuVisible(true)} className="green-button outline user">
            <img alt="" src="images/user-green.svg" />
          </button>
          <div className={`user-menu ${userMenuVisible ? "active" : ""}`}>
            <div className="name">{user ? user.name : ""}</div>
            <div className="email">{user ? user.email : ""}</div>
            <div onClick={()=>logout()} className="logout"><img src="images/main-menu/exit.svg" alt="" /><FormattedMessage id="home.navigation.logout" /></div>
          </div>
        </div>
        <HashLink className="button" smooth to="/app">
          <button className="green-button">
            <FormattedMessage id="home.navigation.toapp" />
            <div className="arrow-wrapper">
              <img alt="" src="images/icons/white-arrow.svg" />
            </div>
          </button>
        </HashLink>
        </> : <>
        <HashLink className="button" to="/login">
          <button className="green-button outline">
            <FormattedMessage id="home.navigation.login" />
          </button>
        </HashLink>
        <HashLink className="button" smooth to="/signup">
          <button className="green-button">
            <FormattedMessage id="home.navigation.register" />
          </button>
        </HashLink>
        </>}
        <div
          onClick={() => setMenuVisible((prev) => !prev)}
          className={`hamburger ${menuVisible ? "active" : ""}`}
        >
          <div className="bar top"></div>
          <div className="bar middle"></div>
          <div className="bar bottom"></div>
        </div>
      </div>
      <div className={`menu navigation-list ${menuVisible ? "active" : ""}`}>
        <HashLink
          onClick={() => setMenuVisible(false)}
          className="a"
          smooth
          to="/#introduction"
        >
          <FormattedMessage id="home.navigation.introduction" />
        </HashLink>
        <HashLink
          onClick={() => setMenuVisible(false)}
          className="a"
          smooth
          to="/#qr-codes"
        >
          <FormattedMessage id="home.navigation.qrcodes" />
        </HashLink>
        <HashLink
          onClick={() => setMenuVisible(false)}
          className="a"
          smooth
          to="/#contact"
        >
          <FormattedMessage id="home.navigation.contact" />
        </HashLink>
        <div
          onClick={() => setLangMenuVisible(!langMenuVisible)}
          className={`lang-button ${langMenuVisible && "active"}`}
        >
          <FormattedMessage id="home.navigation.lang" />
          &nbsp;
          {lang === "cs" ? "CZ" : "EN"}
          <img src="/lib/images/arrow-gray.svg" alt="" />
          <div className={`lang-menu ${langMenuVisible && "active"}`}>
            <span
              onClick={() => {
                handleLanguage("cs");
              }}
            >
              Česky
            </span>
            <span
              onClick={() => {
                handleLanguage("en");
              }}
            >
              English
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapDispatch = (dispatch) => ({
  setLocale: (type) => dispatch(setCurrentLocale(type)),
  logout: (type) => dispatch(logout(type)),
});
const mapState = (state) => ({
  user: getUserSettings(state),
});

export default connect(mapState, mapDispatch)(Navigation);
